import * as React from 'react';
import '../playerstatselection.css'
import PlayerSetup from "../PlayerSetup/index";
import RiotDB from "../../fbobjects/RiotDB";
import GoogleSheetDB from "../../fbobjects/GoogleSheetDB";
import FBOM from "../../fbobjects/framework/FBOM";
import Simulation from "../../fbobjects/Simulation";
import _ = require("lodash");
import SimulationActions from "../../actions/SimulationActions";
import FBSyncBase from "../../fbobjects/framework/FBSyncBase";
import {IHash} from "../../fbobjects/framework/CommonInterfaces";
import DCContainer from "../DCContainer/index";
import SimPlayer from "../../fbobjects/calculation/SimPlayer";
import './simulationcomponent.css';
import KillPageStore from "../../fbobjects/KillPageStore";
import IntroC from "../IntroC/index";
import LoginModalC from "../LoginModalC/index";

interface SimulationState {
    isLoaded:boolean,
    simulation:Simulation,
    curGameSearchText:string,
    meSelected:boolean,
}

interface SimulationComponentProps{
    match:any;
    history:any;
}

export default class SimulationComponent extends React.Component<SimulationComponentProps,SimulationState> {

    handleChangeIds:IHash<string> = {};
    state:SimulationState = {
        curGameSearchText:"",
        simulation: undefined,
        isLoaded: false,
        meSelected:true,
    };

    props:SimulationComponentProps;
    cbId:string;


    constructor(props:any){
        super(props);

        this.props = props;

        this.loadSimulation(this.props);
		this.cbId = KillPageStore.onChange(()=>{
        	this.forceUpdate();
		});

    }

    componentWillReceiveProps(nextProps){
        this.loadSimulation(nextProps);
    }

    componentWillUnmount(){
        _.forOwn(this.handleChangeIds, (value, key)=>{
            FBOM.removeObjectChangeHandler(value);
        });

		if(this.cbId){
        	KillPageStore.removeOnChange(this.cbId);
		}

    }

    //TODO think about removing change handlers when ID is changed as well



    setupOnChangeHandler(key:string, obj:FBSyncBase){
        if (this.handleChangeIds[key] != undefined){
            FBOM.removeObjectChangeHandler(this.handleChangeIds[key]);
        }
        this.handleChangeIds[key] = FBOM.onObjectChange(obj.id, ()=>{this.forceUpdate()})
    }

    loadSimulation(props){
        if(props.match.params.id == undefined){
            (async() => {
                let sim = await SimulationActions.createSimulationP();
                props.history.push(`/simulation/${sim.id}`);
            })();
        }
        else{
            (async() => {
                KillPageStore.actionLoadSimulation(props.history, props.match.params.id);

            })();
        }
    }

    createDefaultPlayer(player, defaultChamp){
        if (player.selectedChampion == undefined){
            player.selectedChampion = defaultChamp;
        }
        player.selectedRunes = GoogleSheetDB.getDefaultChampionRunesForChampion(player.selectedChampion);
        player.selectedSkillOrder = GoogleSheetDB.getDefaultSkillOrdersForChampion(player.selectedChampion);
    }

    getState():SimulationState{
        return this.state
    }

    handleChangeSourcePlayer(to){
        if (to == "me" && this.state.meSelected != true){
            this.setState({meSelected:true})
        }
        else if (to == 'them' && this.state.meSelected == true){
            this.setState({meSelected:false})
        }
    }


    getSourcePlayer(){
        if (this.state.meSelected == true){
            return KillPageStore.curSimulation.mePlayer;
        }
        return KillPageStore.curSimulation.themPlayer;
    }
    getTargetPlayer(){
        if (this.state.meSelected == false){
            return KillPageStore.curSimulation.mePlayer;
        }
        return KillPageStore.curSimulation.themPlayer;
    }

    getPlayerSelectedButton(type){
        if (type == "me"){
            if (this.state.meSelected){
                return 'button-selected'
            }
            else {
                return 'button-unselected'
            }
        }
        else{
            if (!this.state.meSelected){
                return 'button-selected'
            }
            else {
                return 'button-unselected'
            }
        }
    }

    renderContents():any{
        if (!KillPageStore.curSimulation){
            return "loading";
        }
        else{
            return ([
                <PlayerSetup key={1}
                             player={KillPageStore.curSimulation.mePlayer}
                             playerNumber={1}
                             defaultChampion={"Lux"}
                />,
                <div key={'vs'} className="vs">
                    VS
                </div>,
                <PlayerSetup key={2}
                             player={KillPageStore.curSimulation.themPlayer}
                             playerNumber={2}
                             defaultChampion={"Talon"}
                />
            ])
        }
    }

    renderLoginModal(){
        if (KillPageStore.getUserName() == null){
            return <LoginModalC/>;
        }
        return <div></div>;
    }

    renderDamageChart(){
		if(!KillPageStore.curSimulation.mePlayer.selectedChampion || !KillPageStore.curSimulation.themPlayer.selectedChampion ) {
			return <div>Please select both champions</div>
		}

		return <DCContainer source={this.getSourcePlayer()} target={this.getTargetPlayer()}/>

	}

    render(){

    	if(KillPageStore.curSimulation){
			console.log("about to render source and target");
			console.log(KillPageStore.curSimulation.mePlayer);
			console.log(KillPageStore.curSimulation.themPlayer);
		}


        if (!KillPageStore.curSimulation){
            return <div>Loading</div>
        }
        return(
            <div className="body">

                <IntroC/>

                <div className="champ-select-container">
                    <div className="champ-select-text">
                        CHAMPION SELECT
                    </div>
                </div>
                <div className="player-setup-container">
                    {this.renderContents()}
                </div>
                {/*<div className="simulation-title-container">*/}
                    {/*<div className="simulation-title-text">*/}
                        {/*SIMULATOR*/}
                    {/*</div>*/}
                {/*</div>*/}
                <div className="button-container">
                    <div className={this.getPlayerSelectedButton('me')} onClick={()=>this.handleChangeSourcePlayer('me')}>
                        <div className="champ-button-text">
                            {`${KillPageStore.curSimulation.mePlayer.selectedChampion}'s Damage to ${KillPageStore.curSimulation.themPlayer.selectedChampion}`}
                        </div>
                        <img className="champ-image" src={RiotDB.getChampionSplashImgUrl(KillPageStore.curSimulation.mePlayer.selectedChampion)}/>

                    </div>
                    <div className={this.getPlayerSelectedButton('them')} onClick={()=>this.handleChangeSourcePlayer('them')}>
                        <div className="champ-button-text">
                            {`${KillPageStore.curSimulation.themPlayer.selectedChampion}'s Damage to ${KillPageStore.curSimulation.mePlayer.selectedChampion}`}
                        </div>
                        <img className="champ-image" src={RiotDB.getChampionSplashImgUrl(KillPageStore.curSimulation.themPlayer.selectedChampion)}/>

                    </div>
                </div>



				{this.renderDamageChart()}
                {this.renderLoginModal()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/SimulationComponent/index.tsx